module.exports = "/images/clubspeed.png?c1b3cc214bfa97d30ac23fcb936c32c4";